import { getPatternStyles, patternFns, __spreadValues } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const levelItemConfig = {
transform(props) {
  return __spreadValues({
    flex: "0 0 auto",
    display: "flex",
    alignItems: "center"
  }, props);
}}

export const getLevelItemStyle = (styles = {}) => {
  const _styles = getPatternStyles(levelItemConfig, styles)
  return levelItemConfig.transform(_styles, patternFns)
}

export const levelItem = (styles) => css(getLevelItemStyle(styles))
levelItem.raw = getLevelItemStyle